import { render, staticRenderFns } from "./FacilityMain.vue?vue&type=template&id=30a0bfe4&"
import script from "./FacilityMain.vue?vue&type=script&lang=js&"
export * from "./FacilityMain.vue?vue&type=script&lang=js&"
import style0 from "./FacilityMain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30a0bfe4')) {
      api.createRecord('30a0bfe4', component.options)
    } else {
      api.reload('30a0bfe4', component.options)
    }
    module.hot.accept("./FacilityMain.vue?vue&type=template&id=30a0bfe4&", function () {
      api.rerender('30a0bfe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Visitors/Facility/FacilityMain.vue"
export default component.exports